import {
  BodyModal,
  FooterModal,
  HeadModal,
  ModalWrap,
  OverLay,
  ButtonOutline,
} from "./Modal.styled";
import Icon from "../Icon";
import { tModal } from "../../Models/ModalInterface";
import Text from "../Text";
import Button from "../Button";

const Modal = (props: tModal) => {
  const {
    IconHeader,
    TextHeader,
    TextBody,
    TextButton,
    show,
    handleClose,
    handleOk,
    ButtonCancel,
    colorIcon,
  } = props;

  return (
    <OverLay hidden={!show} onClick={handleClose}>
      <ModalWrap onClick={(event) => event.stopPropagation()}>
        <HeadModal>
          <Icon
            icon={IconHeader}
            size="xxlarge"
            color={colorIcon ? colorIcon : "Primary_600"}
          />
          <Text
            size={3}
            align="center"
            weight={900}
            color="Black"
            margin="32px 40px"
          >
            {TextHeader}
          </Text>
        </HeadModal>
        <BodyModal>
          <Text
            size={1}
            align="center"
            weight={500}
            color="Eerie_Black"
            margin="0 25px 32px 25px"
          >
            {TextBody}
          </Text>
        </BodyModal>
        <FooterModal>
          <Button
            text={TextButton}
            onClick={handleOk}
            colorButton="Primary_600"
          />
          {ButtonCancel && (
            <ButtonOutline onClick={handleClose}>Cancelar</ButtonOutline>
          )}
        </FooterModal>
      </ModalWrap>
    </OverLay>
  );
};

export default Modal;
